import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { Card, CardContent, Typography } from '@mui/material'
import i18n from 'simple-react-i18n'
import { maxBy } from 'lodash'
import { push } from '@lagunovsky/redux-react-router'
import { CardTitle } from '../../../components/card/NewCard'
import { getDateWithHour } from '../../../utils/DateUtil'
import ContactAction from '../../../referencial/components/contact/actions/ContactAction'
import RpqsEventCard from '../events/RpqsEventCard'
import useRpqsEvents from '../events/useRpqsEvents'
import { getEventOriginLabel } from '../events/RpqsEventsUtils'

// Sans egId : dernier événement parmi ceux du RPQS (global + EG) et du référentiel (collectivité + ses EG).
const RpqsLastEventPanel = ({
    year,
    collectivityId,
    egId,
}) => {
    const dispatch = useDispatch()

    const {
        contacts,
        managementUnits,
        collectivity,
        rpqs,
    } = useSelector(store => ({
        contacts: store.ContactReducer.contacts,
        managementUnits: store.RpqsReducer.managementUnits,
        collectivity: store.RpqsReducer.collectivity,
        rpqs: store.RpqsReducer.rpqs,
    }), shallowEqual)

    const [events] = useRpqsEvents(year, collectivityId, egId)

    useEffect(() => {
        dispatch(ContactAction.fetchContacts())
    }, [dispatch])

    const lastEvent = maxBy(events.filter(e => e.date), e => getDateWithHour(e.date, e.hour).valueOf())
    const eventsPath = egId ? `/rpqs/${year}/collectivite/${collectivityId}/eg/${egId}/event` : `/rpqs/${year}/collectivite/${collectivityId}/event`

    return (
        <Card>
            <CardTitle title={i18n.rpqsLastEvent} />
            <CardContent>
                {lastEvent ? (
                    <RpqsEventCard
                        event={lastEvent}
                        contacts={contacts}
                        originLabel={!egId && getEventOriginLabel(lastEvent, managementUnits, collectivity, rpqs)}
                        small
                        onClick={() => dispatch(push(eventsPath))}
                    />
                ) : (
                    <Typography>{i18n.noEvents}</Typography>
                )}
            </CardContent>
        </Card>
    )
}

RpqsLastEventPanel.propTypes = {
    year: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    collectivityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    egId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default RpqsLastEventPanel
